import React from "react";
import { fieldToTextField } from "formik-material-ui";
import { Autocomplete, Paper, TextField } from "@mui/material";
import { theme } from "../../views/App";
const AutoCompleteMultiSelect = ({
  disabled,
  disableClearable,
  textFieldProps,
  size,
  limitTags,
  fieldValue,
  renderOption,
  onChange,
  ...props
}) => {
  const {
    form: { setTouched, setFieldValue, touched },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <Autocomplete
      disableClearable={disableClearable}
      {...props}
      {...field}
      renderOption={renderOption}
      limitTags={limitTags ? limitTags : 3}
      disabled={disabled}
      onChange={
        onChange
          ? onChange
          : (_, value) => {
              setFieldValue(name, value);
            }
      }
      // isOptionEqualToValue={(option, value) =>
      //   //setting value property to custom value
      //   option.project_name === value.project_name
      // }
      // //setting custom label to custom value
      // getOptionLabel={(option) => option.project_name}
      onBlur={() => setTouched({ ...touched, [name]: true })}
      getOptionSelected={(item, current) => item.value === current.value}
      //paper component for styling dropdown list"
      PaperComponent={({ children }) => (
        <Paper
          style={{
            border: `1px solid ${theme.palette.primary.main}`,
            marginTop: 2,
          }}
        >
          {children}
        </Paper>
      )}
      renderInput={(props) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          {...props}
          {...textFieldProps}
          helperText={helperText}
          error={error}
          size={size}
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
          }}
        />
      )}
    />
  );
};

export default AutoCompleteMultiSelect;
